import { SearchTerm } from "./SearchTerm";

const MobileAccountSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "accName",
        translationKey: "name"
    },
    {
        heading: "Description",
        accessor: "description",
        searchOnName: "accountType.atDesc",
        translationKey: "description"
    },
];

export default MobileAccountSearch;
